import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    supportData: {},
    faqSearchData: {},
    faqSearchedKey: {},
    isProgress: false,
    error: '',
  };

  export const supportSlice = createSlice({
    name: "support",
    initialState,
    reducers: {
        fetchSupport: (state, action) => {
            state.isProgress= true
        },
        fetchSupportSuccess: (state, action) => {
            state.isProgress = false;
            state.supportData = action.payload;
            console.log('state.supportData ->', state.supportData);
        },
    },
});


export const {
    fetchSupport,
    fetchSupportSuccess
} = supportSlice.actions;
export const supportData = (state) => (state.support)
export default supportSlice.reducer;
